// btw-front/src/api/adminSalesReps.js
// 관리자 영업대표 CRUD — /admin/sales-reps 페이지 + 관리자 딜 등록 셀렉트 소스.
import { api } from "./client";

async function list() {
  const res = await api.get("/admin/sales-reps");
  return res && res.items ? res.items : [];
}

export const listSalesReps = list;
export const createSalesRep = (payload) => api.post("/admin/sales-reps", payload);
export const updateSalesRep = (id, payload) =>
  api.put(`/admin/sales-reps/${encodeURIComponent(id)}`, payload);
export const deleteSalesRep = (id) => api.del(`/admin/sales-reps/${encodeURIComponent(id)}`);
